export default () => {
  document
    .querySelectorAll(".js-download-print-components")
    .forEach(component => {
      const printBtn = component.querySelector(".js-print-btn");
      const guidelineBtn = component.querySelector(".js-guideline-btn");

      if (printBtn) {
        printBtn.addEventListener("click", () => {
          window.print();
        });
      }

      if (guidelineBtn) {
        guidelineBtn.addEventListener("click", () => {
          const guidelinesEl = document.querySelector("#guidelines");
          if (guidelinesEl) {
            const linkEl = guidelinesEl.querySelector("a");
            if (linkEl && linkEl.href) {
              window.location.href = linkEl.href;
            } else {
              guidelinesEl.scrollIntoView({ behavior: "smooth" });
            }
          }
        });
      }
    });
};
